import KeyboardSymbols from "../../../../src/components/tools/KeyboardSymbols";
import * as React from 'react';
export default {
  KeyboardSymbols,
  React
};